<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <b-col>
        <vd-header :app="app" />

        <b-row class="border py-3">
          <b-col cols="12" xl="4">
            <img src="@shared/assets/foto_1.jpg" class="mastra-logo pb-3 w-100" alt="mastra logo" />

            <p class="font-weight-bold mb-0">Husk - Ønsker og ideer modtages</p>
            <p>
              Har du en ting du savner i {{ AppTypeLabel.get(app) }} eller er der noget som du ikke synes fungerer? Du er altid velkommen til at kontakte os - vi modtager meget gerne kommentarer, som kan hjælpe os til at gøre {{ AppTypeLabel.get(app) }} endnu bedre.
            </p>
          </b-col>
          <b-col cols="12" xl="4">
            <p class="mb-0">
              Med nedenstående link kommer du til en brugervejledning.
            </p>
            <p class="mb-0">
              <a href="../../hastriddok/BrugervejledningTilHastrid11092014.pdf" target="_blank">Brugervejledning</a>
            </p>

            <vd-newsviewer class="mt-3" :app='app'/>            
          </b-col>
          <b-col cols="12" xl="4">
            <img src="@shared/assets/foto_2.jpg" class="w-100 mb-2"/>

            <p class="font-weight-bold mb-0">
              Kontakt
            </p>
            <p clas="mb-0">
              Har du et problem/spørgsmål af trafikfaglig karakter eller et spørgsmål vedr. brugen af {{ AppTypeLabel.get(app) }}, så kontakt Trafikstatistik-afdelingen, <a href="mailto:cjw@vd.dk">Christian Juul Würtz</a>
            </p>
            <p>
              Er dit problem af mere teknisk karakter, så kontakt <a href="mailto:je1@vd.dk">Jakob Elbek</a>
            </p>            
          </b-col>
        </b-row>

        <vd-footer />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import vdHeader from '@shared/components/layout/vdHeader'
import vdFooter from '@shared/components/layout/vdFooter'
import vdNewsviewer from '@shared/components/vdNewsviewer';
import { AppTypeEnum, AppTypeLabel } from '@shared/enums/appTypeEnum';

export default {
  name: 'Hastrid',
  components: {
    vdHeader,
    vdFooter,
    vdNewsviewer
  },
  data: function() {
    console.log()

    return {
      app: AppTypeEnum.Hastrid,
      AppTypeLabel
    }
  }
}
</script>

<style lang="scss">
    @import "@shared/styles/mastra.scss";

    .mastra-logo {
      width: 250px;
    }
</style>